import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: { user: null, organization: null, role: null, acceptedOrgId: null, selectedOrgData: null },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
    setCurrentOrganization: (state, action) => {
      state.organization = action.payload;
    },
    setCurrentOrganizationRole: (state, action) => {
      state.role = action.payload;
    },
    setAcceptedOrgId: (state, action) => {
      state.acceptedOrgId = action.payload;
    },
    setSelectedOrgData: (state, action) => {
      state.selectedOrgData = action.payload;
    }
  },
});

export const { setUser, clearUser, setCurrentOrganization, setCurrentOrganizationRole, setAcceptedOrgId, setSelectedOrgData } = userSlice.actions;
export const currentUser = (state) => state.user.user;
export const currentOrg = (state) => state.user.organization;
export const currentRole = (state) => state.user.role;
export default userSlice.reducer;
